function isEmail(text) {
    return /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(text);
  }
  
  function errorMessage(error) {
    if (!error) return undefined;

    // Axios: parsed JSON body ({ error: { message } } or { error: "..." })
    const data = error?.response?.data;
    if (data?.error?.message) return data.error.message;
    if (typeof data?.error === 'string') return data.error;
    if (typeof data?.message === 'string') return data.message;

    // Axios XHR raw responseText (legacy path)
    const responseText = error?.response?.request?.responseText
      || error?.request?.responseText;
    if (responseText) {
      try {
        const parsed = JSON.parse(responseText);
        if (parsed?.error?.message) return parsed.error.message;
        if (typeof parsed?.error === 'string') return parsed.error;
        if (typeof parsed?.message === 'string') return parsed.message;
      } catch { /* empty */ }
    }

    if (typeof error?.message === 'string' && error.message !== 'Network Error') {
      return error.message;
    }
    return undefined;
  }
  
  export { isEmail, errorMessage };
  
  export function isValidPrice(string) {
    // const regex = /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/;
    // eslint-disable-next-line no-useless-escape
    const regex = /^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/;
    return new RegExp(regex).test(string.toString().split(' ').join(''));
  }
  
  export function isDecimal(string) {
    if (string === null) {
      return false;
    }
    return string.toString().includes('.');
  }
  
  export function isValidUrl(string) {
    try {
      // eslint-disable-next-line no-new
      new URL(string);
      return true;
    } catch (err) {
      return false;
    }
  }
  
  
